<template>
  <div class="media-item">
    <div class="media-thumbnail">
      <img
        v-if="media.resourceType === 'image'"
        :src="imageUrl"
        class="media-image"
        alt="Media thumbnail"
      >
      <div v-else-if="media.resourceType === 'video'" class="video-thumbnail-container">
        <img
          :src="videoUrl"
          class="media-image video-thumbnail"
          alt="Video thumbnail"
          @error="handleThumbnailError"
        >
        <div class="video-placeholder" style="display: none;">
          <ion-icon :icon="videocamOutline" style="font-size: 2.5rem;" />
          <span style="font-size: 0.9rem; font-weight: 600;">{{ media.format?.toUpperCase() || 'VIDEO' }}</span>
        </div>
        <div class="play-overlay">
          <ion-icon :icon="playCircleOutline" class="play-icon" />
        </div>
      </div>
    </div>
    <div style="padding: 0.75rem;">
      <p class="media-index">
        #{{ index + 1 }}
        <span v-if="media.resourceType === 'video' && media.duration">
          - {{ Math.round(media.duration) }} sec
        </span>
      </p>
    </div>
  </div>
</template>

<script setup>
import { playCircleOutline, videocamOutline } from 'ionicons/icons'
import { IonIcon } from '@ionic/vue'
import { useCloudinaryUrls } from './useCloudinaryUrls'

const props = defineProps({
  media: { type: Object, required: true },
  index: { type: Number, required: true },
})

const { getImageThumbnailUrl, getVideoThumbnailUrl } = useCloudinaryUrls()

const imageUrl = props.media.resourceType === 'image' ? getImageThumbnailUrl(props.media) : null
const videoUrl = props.media.resourceType === 'video' ? getVideoThumbnailUrl(props.media.publicId) : null

const handleThumbnailError = (event) => {
  // Hide the failed image and show the placeholder
  event.target.style.display = 'none'
  const placeholder = event.target.parentElement.querySelector('.video-placeholder')
  if (placeholder) {
    placeholder.style.display = 'flex'
  }
}
</script>

<style scoped>
.media-item {
  border: 1px solid var(--ion-color-light);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  position: relative;
}

.media-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.media-thumbnail {
  width: 100%;
  height: 100px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ion-color-light);
}

.media-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.video-thumbnail-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  opacity: 1;
  transition: opacity 0.2s ease;
}

.play-icon {
  font-size: 3rem;
  color: white;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5));
}

.video-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--ion-color-primary-tint), var(--ion-color-primary));
  color: white;
  gap: 0.5rem;
}

.media-index {
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  font-size: 0.85rem;
  color: var(--ion-color-primary);
}
</style>
